import dayjs from 'dayjs';

import type { ImmunizationRecord } from '@models/immunization';
import type { MedicationStatementRecord } from '@models/medication';

import { StatementStatus } from 'generated/types';

export function filterMedications(record: MedicationStatementRecord) {
  return (
    record.status === StatementStatus.active ||
    record.status === StatementStatus.unknown
  );
}

export function filterImmunizations(
  record: ImmunizationRecord,
  i: number,
  a: ImmunizationRecord[]
) {
  const expires = record.getExpiryDate();
  const validDate = !expires || dayjs(expires).isAfter(new Date());

  const matchingIndex = a.findIndex((matchingImmunization) => {
    const rawMatch = matchingImmunization.vaccineName;
    const rawMain = record.vaccineName;

    return rawMatch && rawMain && matchingImmunization.id === record.id;
  });
  return validDate && matchingIndex === i;
}
